module.exports = __webpack_public_path__ + "static/media/tdf.6e01a0ea.jpg";